import { Label, SpinButton, SpinButtonProps, Spinner } from '@fluentui/react-components';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { useEditorStyles } from '../Styles/Editor';
import XMLViewer from "react-xml-viewer";
import { Theme } from "react-xml-viewer/dist/components/types";
import { getDocument, PDFDocumentProxy } from 'pdfjs-dist';
import { CsvViewer } from './CSVFileViewer';
import { useSelector } from 'react-redux';
import { ApplicationState } from '../../store';
import { isThemeDark } from '../../App';
require("pdfjs-dist/webpack.mjs");

export interface FileViewerProp {
    file?: Blob;
}

export const FileViewer = ({ file }: FileViewerProp) => {
    const themeString = useSelector((state: ApplicationState) => state.teamsState.themeString);
    const styles = useEditorStyles();
    const divRef = React.useRef<HTMLDivElement>(null);
    const [zoomLevel, setZoomLevel] = React.useState(1);
    const [pageNumber, setPageNumber] = React.useState(1);
    const [pdf, setPdf] = React.useState<PDFDocumentProxy>();
    const [image, setImage] = React.useState<string>();
    const [xml, setXml] = React.useState<string>();
    const [csv, setCsv] = React.useState<string>();
    const [unknownFile, setUnknownFile] = React.useState(false);
    const [dimensions, setDimensions] = React.useState({ width: 0, height: 0, dimSet: false });
    const { t } = useTranslation();

    React.useEffect(() => {
        if (file) {
            if (file.type === "application/xml") {
                file.text().then((s) => {
                    setCsv(undefined);
                    setXml(s);
                    setImage(undefined);
                    setPdf(undefined);
                    setUnknownFile(false);
                    const canvasObj = document.getElementById("pdf") as HTMLCanvasElement;
                    if (canvasObj) {
                        canvasObj.height = 0;
                        canvasObj.width = 0;
                    }
                });
            }
            else if (file.type === "text/csv") {
                file.text().then((s) => {
                    setCsv(s);
                    setXml(undefined);
                    setImage(undefined);
                    setPdf(undefined);
                    setUnknownFile(false);
                    const canvasObj = document.getElementById("pdf") as HTMLCanvasElement;
                    if (canvasObj) {
                        canvasObj.height = 0;
                        canvasObj.width = 0;
                    }
                });
            }
            else {
                file.arrayBuffer().then((a) => {
                    function isPDFSignature(element: number, index: number, array: Uint8Array) {
                        return index < array.length - 4
                            && array.at(index) === 37//'%'
                            && array.at(index + 1) === 80//'P'
                            && array.at(index + 2) === 68//'D'
                            && array.at(index + 3) === 70//'F'
                            ;
                    }

                    const sliced = new Uint8Array(a.slice(0, 1024));
                    if ((sliced.at(1) === 80//'P'
                        && sliced.at(2) === 78//'N'
                        && sliced.at(3) === 71//'G'
                    )
                        ||
                        (sliced.at(0) === 0xFF// jpg header
                            && sliced.at(1) === 0xD8
                            && sliced.at(2) === 0xFF
                        )
                    ) {
                        window.URL = window.URL || window.webkitURL;
                        setCsv(undefined);
                        setImage(window.URL.createObjectURL(file));
                        setXml(undefined);
                        setPdf(undefined);
                        setUnknownFile(false);
                        const canvasObj = document.getElementById("pdf") as HTMLCanvasElement;
                        if (canvasObj) {
                            canvasObj.height = 0;
                            canvasObj.width = 0;
                        }
                    }
                    else if (sliced.findIndex(isPDFSignature) !== -1) {
                        getDocument({data:a}).promise
                            .then((p) => {
                                setCsv(undefined);
                                setPdf(p);
                                setImage(undefined);
                                setXml(undefined);
                                setUnknownFile(false);
                            })
                            .catch(() => setUnknownFile(true));
                    }
                    //else if (sliced.at(0) === 37//'%'
                    //    && sliced.at(1) === 80//'P'
                    //    && sliced.at(2) === 68//'D'
                    //    && sliced.at(3) === 70//'F'
                    //) {
                    //    getDocument(a).promise.then((p) => setPdf(p));
                    //}
                    else {
                        setCsv(undefined);
                        setPdf(undefined);
                        setImage(undefined);
                        setXml(undefined);
                        setUnknownFile(true);
                        const canvasObj = document.getElementById("pdf") as HTMLCanvasElement;
                        if (canvasObj) {
                            canvasObj.height = 0;
                            canvasObj.width = 0;
                        }
                    }
                });
            }
        }
    }, [file]);

    React.useEffect(() => {
        if (divRef && pdf && divRef.current !== null) {
            // Load information from the first page.
            pdf.getPage(pageNumber).then(function (page) {
                if (pdf && divRef.current !== null) {

                    let scrolSize = divRef.current.offsetWidth - divRef.current.clientWidth;
                    if (scrolSize === 0) {
                        scrolSize = 15;
                    }
                    //let canvH = divRef.current.offsetHeight - 1;
                    const canvW = divRef.current.offsetWidth - 1 - scrolSize;
                    //if (page.view[2] < page.view[3]) {
                    //    canvW = (canvW * page.view[2]) / page.view[3];
                    //}
                    //else {
                    //    canvH = (canvH * page.view[3]) / page.view[2];
                    //}

                    let viewport = page.getViewport({ scale: 1 });

                    //const scaleH = (canvH * zoomLevel) / viewport.height;
                    const scaleW = (canvW * zoomLevel) / viewport.width;
                    //const scale = Math.max(scaleW, scaleH);

                    const canvas = document.createElement("canvas");
                    canvas.width = divRef.current.clientWidth * zoomLevel;
                    canvas.height = divRef.current.clientHeight * zoomLevel;
                    canvas.id = "pdf";
                    canvas.style.position = "absolute";
                    canvas.style.zIndex = "0";
                    viewport = page.getViewport({ scale: scaleW });

                    canvas.width = viewport.width;
                    canvas.height = viewport.height;

                    // Render the page into the `<canvas>` element.
                    const renderContext = {
                        viewport: viewport,
                        canvas: canvas,
                    };
                    page.render(renderContext).promise.then(() => {
                        const canvasObj = document.getElementById("pdf");
                        if (canvasObj) canvasObj.replaceWith(canvas);
                    }
                    )
                        .catch((error) => { console.log(error); });
                }
            })
                .catch((error) => { console.log(error); });
        }

    }, [divRef, pdf, zoomLevel, pageNumber, dimensions]);

    let timeout: number | undefined;

    React.useEffect(() => {
        if (!divRef.current) return;
        const resizeObserver = new ResizeObserver((entries) => {
            for (const entry of entries) {
                clearTimeout(timeout);
                timeout = window.setTimeout(() => {
                    setDimensions({
                        width: entry.contentRect.width,
                        height: entry.contentRect.height,
                        dimSet: true,
                    });
                }, 50);
            }
        });
        resizeObserver.observe(divRef.current);
        return () => resizeObserver.disconnect(); // clean up 
    }, [divRef]);

    const onPageChange: SpinButtonProps["onChange"] = React.useCallback(
        (_ev, data) => {
            if (data.value !== undefined) {
                setPageNumber(data.value ?? 1);
            } else if (data.displayValue !== undefined) {
                const newValue = parseFloat(data.displayValue);
                if (!Number.isNaN(newValue)) {
                    setPageNumber(newValue);
                } else {
                    console.error(`Cannot parse "${data.displayValue}" as a number.`);
                }
            }
        },
        [setPageNumber]
    );
    const onZoomChange: SpinButtonProps["onChange"] = React.useCallback(
        (_ev, data) => {
            if (data.value !== undefined) {
                setZoomLevel(data.value ?? 1);
            } else if (data.displayValue !== undefined) {
                const newValue = parseFloat(data.displayValue);
                if (!Number.isNaN(newValue)) {
                    setZoomLevel(newValue);
                } else {
                    console.error(`Cannot parse "${data.displayValue}" as a number.`);
                }
            }
        },
        [setZoomLevel]
    );

    const theme: Theme = {
        tagColor: "#d43900",
        textColor: "#FFFF00",
        attributeKeyColor: "#2a7ab0",
        attributeValueColor: "#008000",
        separatorColor: "#333",
        commentColor: "#aaa",
        cdataColor: "#1D781D",
        fontFamily: "monospace",
        lineNumberBackground: "#eee",
        lineNumberColor: "#222",
    };
    if (!isThemeDark(themeString)) {
        theme.textColor = "#000000";
    }

    return <div className={styles.FilePreviewPart}>
        <div className={styles.spaceBetween2}>
            {pdf &&
                <div className={styles.Horizontal}>
                    <Label className={styles.label2}>Zoom</Label>
                    <SpinButton
                        value={zoomLevel}
                        onChange={onZoomChange}
                        displayValue={`${zoomLevel}x`}
                        min={1}
                        max={5}
                    />
                </div>
            }
            {pdf && pdf.numPages > 1 &&
                <div className={styles.Horizontal}>
                    <Label className={styles.label2}>Page</Label>
                    <SpinButton
                        value={pageNumber}
                        onChange={onPageChange}
                        min={1}
                        max={pdf.numPages}
                    />
                </div>
            }
        </div>
        <div id="PreviewDivId" ref={divRef} className={styles.FilePreviewPart2}>
            <canvas id="pdf" className={styles.FilePreviewPart3}></canvas>
            {unknownFile &&
                <Label>Unknown File Format</Label>
            }
            {image !== undefined &&
                <img alt="" src={image} />
            }
            {csv !== undefined &&
                <CsvViewer csv={csv} />
            }
            {xml !== undefined &&
                <div style={{ margin: '5px'/*, backgroundColor: "white"*/ }}>
                    <XMLViewer xml={xml} collapsible={true} invalidXml={<p>Invalid Xml</p>} theme={theme} />
                </div>
            }
            {pdf === undefined && image === undefined && xml === undefined && csv === undefined && !unknownFile &&
                <Spinner labelPosition="below" label={t('LoadingDocuments')} />
            }
        </div>
    </div>;
};